/**
 * SN_SAI_MDL_REG_001 — 모델 배정 (본사) (2026-09-18, 2차 검토 확정)
 *
 * 줄 = 용도 4개 고정(대화 일반 · 대화 고급 · 대화압축 · 문서인식), 칸 = LLM회사(OpenAI · Claude · Gemini)마다 모델 콤보(공통코드 SAI031 AI모델).
 * 콤보만 바꿔 [저장]. 서버가 칸을 sai_model_map 줄(회사 × 용도 × 등급)로 풀어 넣고, 모델 코드의 상위 회사가 칸의 회사와 같은지 · 오늘 단가가 있는지 검사한다.
 * 빈 칸 = 그 회사는 이 용도 안 함. 행추가 · 삭제 없음. 새 모델 = 코드관리(SAI031)에 한 줄 + 단가 관리에 단가.
 *
 * 조회조건 · 그리드 컬럼 · 폼 · 팝업 정의는 DB(sys_formctrl · sys_formgridcolumn · sys_popup*, 08_AI_화면설정.sql)에서 온다. 조회는 sys_query sn_sai_mdl_reg_001_01.
 * 본 : 사용자 등록 SN_SYS_AUT_REG_004 (그리드 1, 조회조건 없음)
 */
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";

interface Props {
  Menuprops: menuInfo;
}

const SN_SAI_MDL_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const [initFlag, setInitFlag] = useState<boolean>(false);
  useEffect(() => {
    if (initFlag) {
      onSearch();
      setInitFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initFlag]);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1 || [],
        });
        setInitFlag(true);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch, onInsert, onDelete, onSave,
  }));

  const onSearch = async () => {
    if (
      gridRefs.current["grid1"].current.getChange().modifiedRowcount > 0
    ) {
      const confirm = await showDialog("confirmCancel", "수정된 내용이 있습니다. 저장하시겠습니까?");
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      } else if (confirm === undefined) {
        return;
      }
    }
    try {
      /* 다시 읽기 전에 수정 표시를 지운다. 안 지우면 아니오를 눌러도 "수정 중" 으로 남는다 */
      gridRefs.current["grid1"].current?.resetUpdate?.();
      const params = {
        id: "sn_sai_mdl_reg_001_01",
        params: {},
      };
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data?.[0] || [],
      });
    } catch (error: any) {}
  };

  const onInsert = async () => {
    try {
      await showDialog("alter", "용도 4줄은 고정입니다. 칸의 모델만 골라 저장하세요.");
    } catch (error: any) {}
  };
  const onDelete = async () => {
    await showDialog("alter", "줄은 지우지 않습니다. 그 회사가 이 용도를 안 하면 칸을 비우고 저장하세요.");
  };
  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      if (!gridRefs.current["grid1"].current.requiredValuesCheck()) return false;
      const sai_model_mapChanges = gridRefs.current["grid1"].current.getChange();
      if (sai_model_mapChanges.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }
      const saveData: any = {
        sai_model_map: sai_model_mapChanges,
      };
      const ok = await fnSave("SN_SAI_MDL_REG_001_SAVE_01", saveData);
      if (!ok) return false;
      gridRefs.current["grid1"].current.resetUpdate();
      await onSearch();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current?.resetUpdate(true);
      return false;
    }
  };
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="w-full flex h-full min-h-0 space-x-1.5">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "모델 배정" }}
            events={grids.grid1.events}
          />
      </div>
    </div>
  );
});

export default SN_SAI_MDL_REG_001;
